'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = void 0;
var $ = require("jquery");
var Category = /** @class */ (function () {
    function Category() {
        $('.trigFilterCategory').on('click', function (e) {
            var filter = $(e.currentTarget).attr('data-filter');
            if (filter === 'all') {
                $('.bulletFilterCategory').show();
            }
            else {
                $('.bulletFilterCategory').hide();
                $("." + filter).show();
            }
        });
    }
    return Category;
}());
exports.Category = Category;
exports.default = Category;
